<template>
    <div class="foreignTrade">
        <banner></banner>
        <div class="container">
            <div class="midBox">
                <div class="boxTit"> 四大核心服务，稳固支撑您的全球市场拓展之路</div>
                <div class="columnBox">
                    <div class="topRow">
                        <div class="leftInfo">
                            <div class="tit">商通中心为企业提供一站式外贸综合服务</div>
                            <div>
                                商通中心为企业提供一站式外贸综合服务，依托权威合规评估与全球网络资源，涵盖市场准入认证、国际物流协调、贸易合规咨询及出口通关保障等核心环节。我们致力于通过专业化、数字化服务解决方案，有效降低企业出海成本与风险，助力中国产品高效开拓国际市场。
                            </div>
                            <div class="tabTit">
                                <div class="titItem" :class="{'active':tabIndex==0}" @click="tabIndex=0">全球展会对接</div>
                                <div class="titItem" :class="{'active':tabIndex==1}" @click="tabIndex=1">贸易合规咨询</div>
                                <div class="titItem" :class="{'active':tabIndex==2}" @click="tabIndex=2">出口检测认证</div>
                                <div class="titItem" :class="{'active':tabIndex==3}" @click="tabIndex=3">贸易通关及物流代理</div>

                            </div>
                        </div>
                        <div class="imgBox">
                            <img src="../../assets/images/foreignTrade/boxImg_01.png" alt="">
                        </div>
                    </div>
                    <div class="tabContent">
                        <div class="tabItem" v-show="tabIndex==0">
                            <div class="imgBgBox">
                                <div class="tit">全球展会对接</div>
                                <div class="infoT">
                                    汇聚全球顶级行业展会资源，为企业提供一站式国际会展对接服务。从精准展会推荐、展位预订、报名协助到现场支持，我们全程赋能，助力您高效对接海外客户，成功开拓国际市场。
                                </div>
                            </div>
                            <div class="rowBox">
                                <div class="boxItem">
                                    <img src="../../assets/images/foreignTrade/tabIcon_01.png" alt="">
                                    <div class="tit">展前策划与预定</div>
                                    <div class="infoT">
                                        展会市场匹配、展位策划、预订、搭建及行程规划一站式服务
                                    </div>
                                </div>
                                <div class="boxItem">
                                    <img src="../../assets/images/foreignTrade/tabIcon_02.png" alt="">
                                    <div class="tit">展中活动与对接</div>
                                    <div class="infoT">
                                        特邀买家对接、现场活动策划、品牌媒体推广及市场调研服务
                                    </div>
                                </div>
                                <div class="boxItem">
                                    <img src="../../assets/images/foreignTrade/tabIcon_03.png" alt="">
                                    <div class="tit">展后跟进与转化</div>
                                    <div class="infoT">
                                        客户名单分析、销售跟进指导、参展总结报告及下届规划建议
                                    </div>
                                </div>
                            </div>
                            <div class="boxBtn" @click="goPage('./exhibitionCenter')">查看展会详情</div>
                        </div>
                        <div class="tabItem" v-show="tabIndex==1">
                            <div class="imgBgBox imgBgBox1">
                                <div class="tit">贸易合规咨询</div>
                                <div class="infoT">
                                    提供专业的全球贸易合规解决方案，依托强大的资深专家团队与动态法规智库，为企业精准解读国际市场规则、制定本土化产品准入策略，并有效规避各类贸易壁垒与清关风险，全力助力企业稳健开拓全球市场，将合规能力转化为可持续的核心竞争力。
                                </div>
                            </div>
                            <div class="rowBox rowBox1">
                                <div class="boxItem">
                                    <img src="../../assets/images/foreignTrade/tabIcon_04.png" alt="">
                                    <div class="tit">海外市场行业分析</div>
                                    <div class="infoT">
                                        提供目标市场的行业趋势、政策动向及竞争格局分析，助力企业做出精准的战略决策
                                    </div>
                                </div>
                                <div class="boxItem">
                                    <img src="../../assets/images/foreignTrade/tabIcon_05.png" alt="">
                                    <div class="tit">目标市场法规咨询</div>
                                    <div class="infoT">
                                        提供全球主要市场的产品技术标准、认证要求及标签包装法规，提供精准的合规指引
                                    </div>
                                </div>
                                <div class="boxItem">
                                    <img src="../../assets/images/foreignTrade/tabIcon_06.png" alt="">
                                    <div class="tit">产品认证及关税优化</div>
                                    <div class="infoT">
                                        为企业规划高效检测路径、快速获取市场准入资质，并灵活运用自贸协定优化原产地，助力企业减免关税
                                    </div>
                                </div>
                                <div class="boxItem">
                                    <img src="../../assets/images/foreignTrade/tabIcon_07.png" alt="">
                                    <div class="tit">贸易壁垒预警</div>
                                    <div class="infoT">
                                        为企业精准追踪国际贸易政策变化，制定专业应对策略，助力企业有效规避国际市场风险
                                    </div>
                                </div>
                            </div>
                            <div class="boxBtn" @click="scrollToDiv('btmBox')">申请咨询服务</div>
                        </div>
                        <div class="tabItem" v-show="tabIndex==2">
                            <div class="imgBgBox imgBgBox2">
                                <div class="tit">出口检测认证</div>
                                <div class="infoT">
                                    提供一站式出口检测与认证服务，依托权威合规评估体系，为您的产品提供从生产到出口的全链条保障，确保符合国际标准，高效获取市场准入，是进军全球高端市场的权威通行证。
                                </div>
                            </div>
                            <div class="rowBox rowBox2">
                                <div class="boxItem">
                                    <img src="../../assets/images/foreignTrade/tabIcon_08.png" alt="">
                                    <div class="tit">出口产品检测</div>
                                    <div class="infoT">
                                        提供一站式出口产品检测服务，内含多款标准检测产品包，可按实际需求灵活选购，高效满足不同市场的准入要求
                                    </div>
                                    <div class="boxBtn" @click="goPage('https://mall.nfstzx.com/mall/goodsDetails?id=5611597568282349453&firstSkuId=6324422506037269268')">查看检测详情</div>
                                </div>
                                <div class="boxItem">
                                    <img src="../../assets/images/foreignTrade/tabIcon_09.png" alt="">
                                    <div class="tit">出口资质认证</div>
                                    <div class="infoT">
                                        提供一站式贸易资质认证服务，涵盖基地、工厂备案及原产地证，高效打通市场准入
                                    </div>
                                    <div class="boxBtn" @click="goPage('https://mall.nfstzx.com/mall/goodsDetails?id=8141478948101653886')">查看认证详情</div>
                                </div>
                                <div class="boxItem">
                                    <div class="innerRowBox">
                                        <div class="">
                                            <img src="../../assets/images/foreignTrade/tabIcon_10.png" alt="">
                                            <div class="tit">欧盟有机认证</div>
                                            <div class="infoT">
                                                提供全流程欧盟有机认证服务，涵盖咨询、审核、申请及维护全环节，助力产品合规准入欧洲市场
                                            </div>
                                        </div>
                                        <div class="">
                                            <img src="../../assets/images/foreignTrade/tabIcon_11.png" alt="">
                                            <div class="tit">出海臻品认证</div>
                                            <div class="infoT">
                                                商通中心提供权威认证，助力优质商品对接高效出口通道，成功开拓国际市场
                                            </div>
                                        </div>
                                    </div>
                                    <div class="boxBtn" @click="scrollToDiv('btmBox')">申请认证服务</div>
                                </div>
                            </div>
                        </div>
                        <div class="tabItem" v-show="tabIndex==3">
                            <div class="imgBgBox imgBgBox3">
                                <div class="tit">贸易通关及物流代理</div>
                                <div class="infoT">
                                    专注出口贸易通关及物流代理服务，汇聚多位从业经验丰富的专业人士为您提供一站式贸易通关及物流代理全流程服务，专业涵盖订舱、报检报关、内陆运输、港口操作及物流跟踪等关键环节，致力于高效协调保障货物安全准时出运，助力企业贸易畅通无阻。
                                </div>
                            </div>
                            <div class="imgBox">
                                <div class="tit">出口贸易服务流程</div>
                                <div class="img">
                                    <img src="../../assets/images/foreignTrade/boxImg_02.png" alt="">
                                </div>
                            </div>
                            <div class="boxBtn" @click="scrollToDiv('btmBox')">申请代理服务</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="btmBox" id="btmBox">
                <div class="boxTit">定制化外贸综合服务</div>
                <div class="smallTit">服务流程</div>
                <div class="flowBox">
                    <div class="flowItem">
                        <div class="flowTit">01</div>
                        <div class="flowInfo">用户提出申请</div>
                    </div>
                    <div class="flowIcon">
                        <img src="../../assets/images/foreignTrade/flowIcon.png" alt="">
                    </div>
                    <div class="flowItem">
                        <div class="flowTit">02</div>
                        <div class="flowInfo">商通中心受理&咨询</div>
                    </div>
                    <div class="flowIcon">
                        <img src="../../assets/images/foreignTrade/flowIcon.png" alt="">
                    </div>
                    <div class="flowItem">
                        <div class="flowTit">03</div>
                        <div class="flowInfo">签订合同及付款</div>
                    </div>
                    <div class="flowIcon">
                        <img src="../../assets/images/foreignTrade/flowIcon.png" alt="">
                    </div>
                    <div class="flowItem">
                        <div class="flowTit">04</div>
                        <div class="flowInfo">商通中心提供服务</div>
                    </div>
                    <div class="flowIcon">
                        <img src="../../assets/images/foreignTrade/flowIcon.png" alt="">
                    </div>
                    <div class="flowItem">
                        <div class="flowTit">05</div>
                        <div class="flowInfo">服务交付</div>
                    </div>
                </div>
                <div class="smallTit">服务咨询</div>
                <customConsult :applyTypeList="applyTypeList" :themeColor="themeColor"></customConsult>
            </div>
        </div>
    </div>
</template>
<script>
import { ref, getCurrentInstance, reactive, computed ,toRefs} from "vue";
import { useRouter, useRoute } from "vue-router";
import customConsult from "./components/customConsult.vue";
import banner from '@/components/banner.vue'
export default {
    name: "foreignTrade",
    props:{
        themeColor: {
            type: String,
            default: 'blue'
        },
    },
    components: {
        customConsult,banner
    },
    setup() {
        const { proxy } = getCurrentInstance();
        const router = useRouter();
        const route = useRoute();
        const state = reactive({
            tabIndex: 0,
        });
        //页面跳转
        const goPage = (url) => {
            if (url) {
                window.open(url);
            }
        };
        //滚动到指定div
        const scrollToDiv = (id) => {
            let el = document.getElementById(id)
            let position = el.getBoundingClientRect().top + window.pageYOffset - 260;
            window.scrollTo({
                top: position,
                left: 0,
                behavior: 'smooth'
            });
        }
        //获取申请类型
        const applyTypeList = ref([]);
        const getApplyType = ()=>{
            proxy.$request({
                url: 'QPSTZX_WMFW_FLLIST',
                method: "post",
                data:{}
            }).then((res) => {
                console.log(res);
                if(res.data.code=='000'){
                    applyTypeList.value = res.data.result
                }
            }).catch((err) => {
                console.log(err);
            })
        }
        getApplyType()
        return {
            goPage,
            scrollToDiv,
            ...toRefs(state),
            applyTypeList,
        }
    },
}
</script>
<style lang="less" scoped>
.foreignTrade{
    width: 100%;
    height: 100%;
    background: #F7F7F7 ;
    box-sizing: border-box;
    padding-bottom: 50px;
    div{
        box-sizing: border-box;
        color: #191919;
        font-size: 16px;
        line-height: 22px;
        font-family: PingFangSC, PingFang SC;
    }
    img{
        width: 100%;
        height: 100%;
    }
    .boxTit{
        font-weight: 600;
        font-size: 36px;
        line-height: 50px;
        text-align: center;
    }
    .container{
        width: 1200px;
        margin: 0 auto;
        .midBox{
            .boxTit{
                padding: 50px 0 60px;
            }
            .columnBox{
                .topRow{
                    display: flex;
                    justify-content: space-between;
                    border-bottom: 1px solid #D8D8D8;
                    margin-bottom: 40px;
                    .leftInfo{
                        flex: 1;
                        padding-top: 78px;
                        font-weight: 400;
                        font-size: 18px;
                        color: #595959;
                        line-height: 36px;
                        display: flex;
                        flex-direction: column;
                        .tit{
                            font-weight: 600;
                            font-size: 30px;
                            line-height: 36px;
                            margin-bottom: 28px;
                        }
                        .tabTit{
                            margin-top: auto;
                            display: flex;
                            .titItem{
                                font-weight: 600;
                                margin-right: 40px;
                                padding-bottom: 10px;
                                cursor: pointer;
                            }
                            .active{
                                font-size: 20px;
                                border-bottom: 4px solid #191919;;
                            }
                        }
                    }
                    .imgBox{
                        width: 47%;
                        height: auto;
                        img{
                            object-fit: contain;
                        }
                    }
                }
                .tabContent{
                    .tabItem{
                        .imgBgBox{
                            // height: 194px;
                            height: 260px;
                            width: 100%;
                            background: url(../../assets/images/foreignTrade/tabBgImg_01.png) right top no-repeat;
                            background-size: auto 100%;
                            background-position: right top;
                            padding-left: 69px;
                            padding-top: 66px;
                            // padding-top: 30px;
                            margin-bottom: 30px;
                            border-radius: 25px;
                            .tit{
                                font-size: 34px;
                                line-height: 48px;
                                margin-bottom: 16px;
                                font-weight: bold;
                            }
                            .infoT{
                                font-weight: 400;
                                font-size: 16px;
                                line-height: 28px;
                                max-width: 61%;
                            }
                        }
                        .imgBgBox1{
                            background: url(../../assets/images/foreignTrade/tabBgImg_02.png) right top no-repeat;
                            background-size: auto 100%;
                        }
                        .imgBgBox2{
                            background: url(../../assets/images/foreignTrade/tabBgImg_03.png) right top no-repeat;
                            background-size: auto 100%;
                        }
                        .imgBgBox3{
                            background: url(../../assets/images/foreignTrade/tabBgImg_04.png) right top no-repeat;
                            background-size: auto 100%;
                        }
                        .imgBox{
                                width: 100%;
                                margin-top: 30px;
                                padding: 32px 170px 39px 69px; 
                                background: #FFFFFF;
                                border-radius: 20px;
                            .tit{
                                font-weight: 600;
                                font-size: 20px;
                                line-height: 28px;
                                margin-bottom: 30px;
                            }
                            .img{
                                height: 230px;
                                img{
                                    object-fit: contain;
                                }
                            }
                        }
                    }
                    .boxBtn{
                        width: 156px;
                        height: 46px;
                        border-radius: 23px;
                        border: 1px solid #191919;
                        text-align: center;
                        line-height: 46px;
                        font-weight: 400;
                        font-size: 14px;
                        margin: 0 auto;
                        margin-top: 40px;
                        cursor: pointer;
                    }
                    .rowBox{
                        display: grid;
                        grid-template-columns: repeat(3, 1fr);
                        grid-column-gap: 20px;
                        grid-auto-rows: 230px;
                        .boxItem{
                            padding: 30px;
                            background: #fff;
                            border-radius: 20px;
                            img{
                                width: 50px;
                                height: 50px;
                                margin-bottom: 30px;
                            }
                            .tit{
                                font-weight: 600;
                                font-size: 20px;
                                line-height: 28px;
                                margin-bottom: 8px;
                            }
                            .infoT{
                                font-weight: 400;
                                font-size: 16px;
                            }
                        }
                    }
                    .rowBox1{
                        grid-template-columns: repeat(4, 1fr);
                        grid-auto-rows: 258px;
                        .boxItem{
                            display: flex;
                            flex-direction: column;
                            .boxBtn{
                                margin-top: auto;
                            }
                        }
                    }
                    .rowBox2{
                        grid-template-columns: 1fr 1fr 2fr;
                        grid-auto-rows: 343px;
                        .boxItem{
                            display: flex;
                            flex-direction: column;
                            .boxBtn{
                                margin-top: auto;
                            }
                        }
                        .innerRowBox{
                            display: flex;
                            justify-content: space-between;
                            column-gap: 50px;
                        }
                    }
                }
            }
        }
        .btmBox{
            .boxTit{
                padding: 55px 0 16px;
            }
            .smallTit{
                font-weight: 600;
                font-size: 20px;
                line-height: 28px;
                margin-bottom: 30px;
                text-align: center;
            }
            .flowBox{
                display: flex;
                align-items: center;
                justify-content: space-between;
                height: 135px;
                background: #FFFFFF;
                border-radius: 20px;
                padding: 0 130px;
                margin-bottom: 30px;
                .flowItem{
                    display: flex;
                    flex-direction: column;
                    .flowTit{
                        font-size: 20px;
                        font-weight: bold;
                        background-image: -webkit-linear-gradient(180deg, #7AAEFF 0%, #2280FF 100%);
                        -webkit-background-clip: text;
                        -webkit-text-fill-color: transparent;
                        margin-bottom: 20px;
                    }
                }
                .flowIcon{
                    width: 28px;
                    height: 36px;
                }
            }
        }
    }
}
@media (min-width: 1680px) {
    .foreignTrade{
        .container{
            width: 1600px;
            .midBox{
                .columnBox{
                    .topRow{
                        .leftInfo{
                            margin-right: 140px;
                        }
                        .imgBox{
                            width: 48%;
                            height: auto;
                        }
                    }
                    .tabContent{
                        .tabItem{
                            .imgBox{
                                .img{
                                    height: 310px;
                                    img{
                                        object-fit: contain;
                                    }
                                }
                            }
                        }
                        .rowBox{
                            grid-auto-rows: 210px;
                        }
                        .rowBox1{
                            grid-auto-rows: 241px;
                        }
                        .rowBox2{
                            grid-auto-rows: 333px;
                        }
                    }
                }
            }
        }
    }
}
</style>